import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";

export function findParentNodesFromMultipleFolderIds(tree, folderIds: number[]) {
    let resultDistinctArray = [];
    folderIds.forEach((folderId) => {
        findParentNodesFromFolderId(tree, folderId).forEach((node) => {
            if (resultDistinctArray.map((n) => n.id).indexOf(node.id) < 0) resultDistinctArray.push(node);
        });
    });
    return resultDistinctArray;
}

export function findParentNodesFromFolderId(tree, folderId: number) {
    let result = [];
    tree.forEach((rootNode) => {
        let res = findParentNodesByNode(rootNode, folderId);
        if (Array.isArray(res) && res.length > 0) result = res.concat([rootNode]);
    });
    return result;
}

export function findParentNodesByNode(node, folderId: number) {
    if (Array.isArray(node.children)) {
        for (let child of node.children) {
            if (node.id == folderId && node.type == DeviceTreeNodeTypeEnum.Folder) return [node];
            else if (child.type == DeviceTreeNodeTypeEnum.Folder) {
                const childResult = findParentNodesByNode(child, folderId);
                if (Array.isArray(childResult) && childResult.length > 0) {
                    if (child.id == folderId) return childResult;
                    else return childResult.concat(child);
                }
            }
        }
    }
}

export function findParentNodesFromInstallationName(tree, installationName: string) {
    let result = [];
    // recupero l'id della cartella in cui è contenuto il device
    let folderId = getInstallationParentId(tree, installationName);
    if (folderId != -1)
        tree.forEach((rootNode) => {
            let res = findParentNodesByNode(rootNode, folderId);
            if (Array.isArray(res) && res.length > 0) {
                if (res.filter((n) => n.id == rootNode.id).length == 0) result = res.concat([rootNode]);
                else result = res;
            }
        });
    return result.reverse();
}

export function getFoldersPathFromFolderId(tree, folderId: number) {
    let result = [];
    if (folderId != -1)
        tree.forEach((rootNode) => {
            let res = findParentNodesByNode(rootNode, folderId);
            if (Array.isArray(res) && res.length > 0) {
                if (res.filter((n) => n.id == rootNode.id).length == 0) result = res.concat([rootNode]);
                else result = res;
            }
        });
    return result.reverse();
}

export function getInstallationParentId(tree, installationName: string) {
    let result = -1; // ritorno -1 se non trovo il dispositivo
    tree.forEach((node) => {
        if (Array.isArray(node.children)) {
            for (let child of node.children) {
                if (child.id == installationName && child.type == DeviceTreeNodeTypeEnum.Device) result = node.id;
                else if (child.type == DeviceTreeNodeTypeEnum.Folder) {
                    const childResult = getInstallationParentId([child], installationName);
                    if (childResult != -1) result = childResult;
                }
            }
        }
    });
    return result;
}
